import {ModelInterface} from "./collection-proto"
import Config from "../config/config";

const debug = false
// const debug = "ModelProto"

export default class ModelProto implements ModelInterface {

    id              : ID
    name            : string

    capture1from    : string
    capture1to      : string
    capture2from    : string
    capture2to      : string

    coordinates     : string
    description     : string
    icon            : string
    icon_size       : number[]

    number          : number

    radius          : number
    skill           : string

    lat             : number
    lng             : number

    customColor     : string

    customIcon      : any

    constructor(data:any) {

        this.id                 = data['id']
        this.name               = data['name']

        this.capture1from       = data['capture1from']
        this.capture1to         = data['capture1to']
        this.capture2from       = data['capture2from']
        this.capture2to         = data['capture2to']

        this.coordinates        = data['coordinates']
        this.description        = data['description']
        this.icon               = data['icon']
        this.icon_size          = !_.isEmpty(data['icon_size']) ? data['icon_size'] : [24,24]

        this.number             = data['number']

        this.radius             = data['radius']
        this.skill              = data['skill']

        debug && console.log(debug, 'constructor', data, this)

        const latlng = this.coordinates.split(',')
        this.lat = parseFloat(latlng[0])
        this.lng = parseFloat(latlng[1])

        this.customColor        = _.get(data, 'customColor', '#b30000')
        if (!this.icon) {
            this.customIcon = {
                url     : require('../assets/custom-point-default.png'),
                anchor  : { x: 15, y: 38 },
                tint    : this.customColor
            }
        }
    }

    get position() {
        return {
            lat: this.lat,
            lng: this.lng
        }
    }

    get markerIcon() {
        return {}
    }

    get availabilityHours() {
        return "{0}{1}{2}".f(
            !!this.capture1from && !!this.capture1to && this.capture1from !== this.capture1to ? "с {0} по {1}".f(this.capture1from,this.capture1to) : "",
            !!this.capture1from && !!this.capture2from && this.capture1from !== this.capture2from ? " " : "",
            !!this.capture2from && !!this.capture2to && this.capture2from !== this.capture2to ? "с {0} по {1}".f(this.capture2from,this.capture2to) : ""
        )
    }
    get skillValues() {
        let matches
        if (this.skill) {
            const regexp2 = new RegExp(/((ни один из)|(любой из)|(ни одна из)|(любая из))\((.+)\)/, 'gmis')
            matches = [...this.skill.matchAll(regexp2)]

            if (_.isEmpty(matches)) {
                // console.error("ModelProto skillValues error:", this.skill, matches)
                return this.skill !== '-' ? this.skill : null
            }

            return '{0} ({1})'.f(matches[0][1], matches[0][6])
        }

        return null
    }

    toJSON() {
        let res = {}
        _.mapKeys(this, (value:any,key:number)=>{
            // @ts-ignore
            res[key] = value
        })
        return res
    }
}
